module.exports = __webpack_public_path__ + "static/media/microscopy-yliv-01 2.24450afe.png";